import { render, staticRenderFns } from "./DialogGohenshin.vue?vue&type=template&id=def8a600&scoped=true"
import script from "./DialogGohenshin.vue?vue&type=script&lang=js"
export * from "./DialogGohenshin.vue?vue&type=script&lang=js"
import style0 from "./DialogGohenshin.vue?vue&type=style&index=0&id=def8a600&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def8a600",
  null
  
)

export default component.exports